import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {Router} from '@angular/router';
import swal from 'sweetalert';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  
  arr_user_low =[];
  count_low=0
  arr_user_medium =[];
  count_medium=0
  arr_user_sell =[];
  count_sell=0
  s
  
  name_show_use;
  timerVar:any;

  count_chat_show_1=0;
  count_warning_show_1=0;

  compound='0';
  wait="รอสูตร";

  uid;
  username;
  password;
  tel;
  username_cut;

  image_topview ='../../assets/imgs/occbanner3.gif';
  image_topview2 ='../../assets/imgs/occbanner2.gif';
  image_topview3 ='../../assets/imgs/occbanner2.gif';
  image_topview4 ='../../assets/imgs/imagetop4.JPG';
 
  image_topview5 ='../../assets/imgs/31.jpg';
  image_topview6 ='../../assets/imgs/32.jpg';
  image_topview7 ='../../assets/imgs/33.jpg';
  image_topview8 ='../../assets/imgs/35.jpg';

  count_x=0;
  count_y=0;
  array_a :any [] =[0,0,0,0,0,0];
  array_b :any [] =[0,0,0,0,0,0];
  array_c :any [] =[0,0,0,0,0,0];
  array_d :any [] =[0,0,0,0,0,0];
  array_e :any [] =[0,0,0,0,0,0];
  array_f :any [] =[0,0,0,0,0,0];
  array_g :any [] =[0,0,0,0,0,0];
  array_h :any [] =[0,0,0,0,0,0];
  array_i :any [] =[0,0,0,0,0,0];
  array_j :any [] =[0,0,0,0,0,0];
  array_k :any [] =[0,0,0,0,0,0];
  array_l :any [] =[0,0,0,0,0,0];

  winer=0;
  loser=0;

  array_calculate :any []= ['ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี',
                            'ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี',
                            'ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี',
                            'ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี',
                            'ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี',
                            'ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี','ไม่มี',
                          ]
  count_calculate=-1;

 
  playercoin ='../../assets/imgs/playercoin.JPG';
  bankercoin ='../../assets/imgs/bankercoin.JPG';
  tiecoin  ='../../assets/imgs/tiecoin.JPG';

  constructor(private router: Router,
    public db : AngularFireDatabase
    ) 
    {
      this.uid = localStorage.getItem('uid');
      this.username = localStorage.getItem('username');
      this.password = localStorage.getItem('password');
      this.tel = localStorage.getItem('tel');

      if(this.username != null){
         var n = this.username.search("@");
         this.username_cut = this.username.substring(0, n);
      }

      console.log(this.uid);
      console.log(this.username);
      console.log(this.password);
      console.log(this.tel);

      this.startTimer2();
     }

  ngOnInit() {
    this.get_data_user();
  }
  startTimer2(){
    this.timerVar = Observable.interval(1000).subscribe(x =>{
      this.get_count_warning();
      this.get_count_chat();
    })
  }
  get_data_user(){


    console.log('1')
    this.arr_user_low=[];
    this.arr_user_medium=[];
    this.arr_user_sell =[];

    this.s = this.db.database.ref('user')
    this.s.on('child_added',snap=>{
      var data = {data:snap.val(),key:snap.key}
      if(snap.val().category_user_select === 'sell'){
        this.count_sell++;
        this.arr_user_sell.push(data)
        console.log(this.arr_user_sell)
      }else if (snap.val().category_user_select === 'buy_low'){
        this.count_low++;
        this.arr_user_low.push(data)
        console.log(this.arr_user_low)
      }else if (snap.val().category_user_select === 'buy_medium'){
        this.count_medium++;
        this.arr_user_medium.push(data)
        console.log(this.arr_user_medium)
      }
      
    })
    
  }

  show_use(name_cat){



    this.name_show_use = name_cat
    console.log(this.name_show_use)
  }


  get_count_warning(){
    var count_warning =0;
    this.s = this.db.database.ref('location').orderByChild('status_bill/value_bill').equalTo('on')
    this.s.on('child_added',snap=>{
      count_warning++;

      if(this.count_warning_show_1 <= count_warning){
        this.count_warning_show_1 = count_warning;
      }
      
    })
  }

  get_count_chat(){
    var count_chat=0;
    // // get ใส่ storage แล้วดึงมาเอา ให้ได้ทุกหน้าเลย
    // this.storage.get('count_chat').then((val)=>{
    //   this.count_chat_show_1 = val;
    // });
    this.s = this.db.database.ref('location/'+'admin_chat'+'/main_chat/chat_select').orderByChild('count_chat').equalTo('on');
    this.s.on('child_added',snap =>{
      count_chat++;
    
      if(this.count_chat_show_1 <= count_chat ){
        this.count_chat_show_1 = count_chat;
        // this.storage.set('count_chat',count_chat);
      }
    })
   }


  //  count_x=0;
  //  count_y=0;
  // array_a :any [] =[0,0,0,0,0,0];
  // array_b :any [] =[0,0,0,0,0,0];
  // array_c :any [] =[0,0,0,0,0,0];
  // array_d :any [] =[0,0,0,0,0,0];
  // array_e :any [] =[0,0,0,0,0,0];
  // array_f :any [] =[0,0,0,0,0,0];
  // array_g :any [] =[0,0,0,0,0,0];
  // array_h :any [] =[0,0,0,0,0,0];
  // array_i :any [] =[0,0,0,0,0,0];
  // array_j :any [] =[0,0,0,0,0,0];
  // array_k :any [] =[0,0,0,0,0,0];
  // array_l :any [] =[0,0,0,0,0,0];

  calculate(){
    // for(var i = 0 ; i<this.array_calculate.length;i++){
    //   console.log(this.array_calculate[i]);
    // }
    var random = Math.floor(Math.random() * 3) + 1 
    if(random == 1){
      this.wait = 'น้ำเงิน'
    }else if(random == 2){
      this.wait ='แดง'
    }else{
      this.wait ='รอสูตร'
    }
    if(this.array_calculate[0]=='น้ำเงิน' && this.array_calculate[1]=='น้ำเงิน' &&
       this.array_calculate[2]=='น้ำเงิน' && this.array_calculate[3]=='น้ำเงิน'){
        this.wait = 'น้ำเงิน';
    }
    if(this.array_calculate[0]=='แดง' && this.array_calculate[1]=='แดง' &&
    this.array_calculate[2]=='แดง' && this.array_calculate[3]=='แดง'){
     this.wait = 'แดง';
    }

    if(this.array_calculate[0]=='น้ำเงิน' && this.array_calculate[1]=='น้ำเงิน' &&
    this.array_calculate[2]=='น้ำเงิน' && this.array_calculate[3]=='เสมอ'){
     this.wait = 'แดง';
    }
    if(this.array_calculate[0]=='แดง' && this.array_calculate[1]=='แดง' &&
    this.array_calculate[2]=='แดง' && this.array_calculate[3]=='เสมอ'){
     this.wait = 'น้ำเงิน';
    }

    if(this.array_calculate[0]=='น้ำเงิน' && this.array_calculate[1]=='น้ำเงิน' &&
    this.array_calculate[2]=='น้ำเงิน' && this.array_calculate[3]=='น้ำเงิน' &&
    this.array_calculate [4] == 'แดง'){
     this.wait = 'น้ำเงิน';
    }

    if(this.array_calculate[0]=='แดง' && this.array_calculate[1]=='แดง' &&
    this.array_calculate[2]=='แดง' && this.array_calculate[3]=='แดง' &&
    this.array_calculate [4] == 'น้ำเงิน'){
     this.wait = 'แดง';
    }

    if(this.array_calculate[0]=='น้ำเงิน' && this.array_calculate[1]=='น้ำเงิน' &&
    this.array_calculate[2]=='น้ำเงิน' && this.array_calculate[3]=='น้ำเงิน' &&
    this.array_calculate [4] == 'แดง' && this.array_calculate [5] == 'น้ำเงิน'){
     this.wait = 'รอสูตร';
    }

    if(this.array_calculate[0]=='แดง' && this.array_calculate[1]=='แดง' &&
    this.array_calculate[2]=='แดง' && this.array_calculate[3]=='แดง' &&
    this.array_calculate [4] == 'น้ำเงิน' && this.array_calculate [5] == 'แดง'){
     this.wait = 'รอสูตร';
    }

    if(this.array_calculate[0]=='แดง' && this.array_calculate[1]=='แดง' &&
    this.array_calculate[2]=='แดง' && this.array_calculate[3]=='เสมอ'){
     this.wait = 'น้ำเงิน';
    }

    if(this.array_calculate[0]=='น้ำเงิน' && this.array_calculate[1]=='น้ำเงิน' &&
    this.array_calculate[2]=='น้ำเงิน' && this.array_calculate[3]=='น้ำเงิน' && 
    this.array_calculate[4]=='น้ำเงิน' && this.array_calculate[5]=='เสมอ' && 
    this.array_calculate[6]=='แดง'){
     this.wait = 'รอสูตร';
    }
    if(this.array_calculate[0]=='แดง' && this.array_calculate[1]=='แดง' &&
    this.array_calculate[2]=='แดง' && this.array_calculate[3]=='แดง' && 
    this.array_calculate[4]=='แดง' && this.array_calculate[5]=='เสมอ' && 
    this.array_calculate[6]=='น้ำเงิน'){
     this.wait = 'รอสูตร';
    }



  }

   reset(){
      this.array_a = [0,0,0,0,0,0];
      this.array_b = [0,0,0,0,0,0];
      this.array_c = [0,0,0,0,0,0];
      this.array_d = [0,0,0,0,0,0];
      this.array_e = [0,0,0,0,0,0];
      this.array_f = [0,0,0,0,0,0];
      this.array_g = [0,0,0,0,0,0];
      this.array_h = [0,0,0,0,0,0];
      this.array_i = [0,0,0,0,0,0];
      this.array_j = [0,0,0,0,0,0];
      this.array_k = [0,0,0,0,0,0];
      this.array_l = [0,0,0,0,0,0];
      this.count_x = 0;
      this.count_y = 0;
      this.winer = 0;
      this.loser = 0;
      this.wait = 'รอสูตร';

   }

   player(){
     if(this.uid != null){
        if(this.wait== 'น้ำเงิน'){
            this.winer++;
        }else if(this.wait == 'แดง'){
            this.loser++;
        }

      // this.wait='รอสูตร';
      console.log('player')
      if(this.count_x == 0){
         this.array_a[this.count_y] = 1; 
      }else if(this.count_x == 1){
         this.array_b[this.count_y] = 1; 
      }else if(this.count_x == 2){
         this.array_c[this.count_y] = 1; 
      }else if(this.count_x == 3){
         this.array_d[this.count_y] = 1; 
      }else if(this.count_x == 4){
         this.array_e[this.count_y] = 1; 
      }else if(this.count_x == 5){
         this.array_f[this.count_y] = 1; 
      }else if(this.count_x == 6){
         this.array_g[this.count_y] = 1; 
      }else if(this.count_x == 7){
         this.array_h[this.count_y] = 1; 
      }else if(this.count_x == 8){
         this.array_i[this.count_y] = 1; 
      }else if(this.count_x == 9){
         this.array_j[this.count_y] = 1; 
      }else if(this.count_x == 10){
         this.array_k[this.count_y] = 1; 
      }else if(this.count_x == 11){
         this.array_l[this.count_y] = 1; 
      }
      this.count_y++;
      if(this.count_y == 6){
         this.count_x++;
         this.count_y=0;
      }
      this.count_calculate++;
      this.array_calculate[this.count_calculate]='น้ำเงิน';
      this.calculate();
     }else{
      this.alert('กรุณาเข้าสู่ระบบก่อน')
    }
    

    
   }
   tie(){
     if(this.uid != null){
      console.log('tie')
      if(this.count_x == 0){
         this.array_a[this.count_y] = 2; 
      }else if(this.count_x == 1){
         this.array_b[this.count_y] = 2; 
      }else if(this.count_x == 2){
         this.array_c[this.count_y] = 2; 
      }else if(this.count_x == 3){
         this.array_d[this.count_y] = 2; 
      }else if(this.count_x == 4){
         this.array_e[this.count_y] = 2; 
      }else if(this.count_x == 5){
         this.array_f[this.count_y] = 2; 
      }else if(this.count_x == 6){
         this.array_g[this.count_y] = 2; 
      }else if(this.count_x == 7){
         this.array_h[this.count_y] = 2; 
      }else if(this.count_x == 8){
         this.array_i[this.count_y] = 2; 
      }else if(this.count_x == 9){
         this.array_j[this.count_y] = 2; 
      }else if(this.count_x == 10){
         this.array_k[this.count_y] = 2; 
      }else if(this.count_x == 11){
         this.array_l[this.count_y] = 2; 
      }
      this.count_y++;
      if(this.count_y == 6){
         this.count_x++;
         this.count_y=0;
      }
      this.count_calculate++;
      this.array_calculate[this.count_calculate]='เสมอ';
      this.calculate();
     }else{
      this.alert('กรุณาเข้าสู่ระบบก่อน')
    }

   }
   banker(){
     if(this.uid != null){
      if(this.wait== 'แดง'){
        this.winer++;
      }else if(this.wait == 'น้ำเงิน'){
        this.loser++;
      }

      // this.wait='รอสูตร';
      console.log('banker')
      if(this.count_x == 0){
         this.array_a[this.count_y] = 3; 
      }else if(this.count_x == 1){
         this.array_b[this.count_y] = 3; 
      }else if(this.count_x == 2){
         this.array_c[this.count_y] = 3; 
      }else if(this.count_x == 3){
         this.array_d[this.count_y] = 3; 
      }else if(this.count_x == 4){
         this.array_e[this.count_y] = 3; 
      }else if(this.count_x == 5){
         this.array_f[this.count_y] = 3; 
      }else if(this.count_x == 6){
         this.array_g[this.count_y] = 3; 
      }else if(this.count_x == 7){
         this.array_h[this.count_y] = 3; 
      }else if(this.count_x == 8){
         this.array_i[this.count_y] = 3; 
      }else if(this.count_x == 9){
         this.array_j[this.count_y] = 3; 
      }else if(this.count_x == 10){
         this.array_k[this.count_y] = 3; 
      }else if(this.count_x == 11){
         this.array_l[this.count_y] = 3; 
      }
      this.count_y++;
      if(this.count_y == 6){
         this.count_x++;
         this.count_y=0;
      }
      this.count_calculate++;
      this.array_calculate[this.count_calculate]='แดง';
      this.calculate();
     }else{
       this.alert('กรุณาเข้าสู่ระบบก่อน')
     }

   }

   alert(message){
    swal("แจ้งเตือน!", message);
  }

   logout(){
    this.uid = null;
    this.username = null;
    this.password = null;
    this.tel = null;
    this.username_cut = null;
    localStorage.removeItem('uid');
    localStorage.removeItem('username');
    localStorage.removeItem('password');
    localStorage.removeItem('tel');
    console.log(this.uid);
    console.log(this.username);
    console.log(this.password);
    console.log(this.tel);
    console.log(this.username_cut);
   }
  
}
